// Module
var code = "<input type=\"text\" id=\"inline-editor\" class=\"inline-editor\" draggable=\"false\" autofocus=\"autofocus\" >";
// Exports
export default code;